export default __webpack_public_path__ + "static/media/smart-prison-solutions_1.6fde8923.jpg";